import React, { useCallback } from "react";
import { DetailedAlert } from "../../../components/DetailedAlert";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportCodeGroupMembersModal = ({ codeGroup, onImport, ...rest }) => {
  const handleImport = useCallback(
    async (values) => {
      const params = {
        file: {
          bytes: values.file,
        },
      };
      const res = await api.post(`/admin/code_groups/${codeGroup.id}/codes/import.json`, snakifyKeys(params));

      onImport?.(res.data?.meta?.message, res.data?.meta?.error_details);
    },
    [codeGroup.id, onImport]
  );

  const details = [
    <ul>
      <li>
        <b>Imports are add-only:</b> they will not remove CPT codes already in this code group.
      </li>
    </ul>,
  ];

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import CPT Codes..."
      exampleDownloadPath={`/admin/code_groups/${codeGroup.id}/codes/example_csv`}
    >
      <DetailedAlert message="CPT Code Import Info" details={details} />
    </ImportModal>
  );
};
